export enum AppTypeCodes {
  MAIN_PAGE = 'MAIN_PAGE',
  TRANSFER = 'TRANSFER', // страница Платежей в тенге
  INTERNATIONAL_TRANSFER = 'INTERNATIONAL_TRANSFER', // страница Валютных переводов
  CONVERSIONS = 'CONVERSIONS',
  CONTRACTORS = 'CONTRACTORS', // страница Корреспондентов
  STATEMENT = 'STATEMENT',
  DEPOSIT = 'DEPOSIT',
  INTERNATIONAL_CONTRACT = 'INTERNATIONAL_CONTRACT',
  INTERNATIONAL_INCOME = 'INTERNATIONAL_INCOME',
}

export enum AppTypeCodesWithHash {
  '/home' = 'MAIN_PAGE',
  '/portal/statement' = 'STATEMENT',
  '/portal/counterparties' = 'CONTRACTORS',
}

export type OnboardingStatus = 1 | 0;

export interface OnboardingSetStatusDto {
  Comment?: string;
  isOnboarding: OnboardingStatus;
  appTypeCode: keyof typeof AppTypeCodes;
}
